export default {
  product: {
    tab2: {
      download: 'Download',
    },
    tab5: {
      manufacturer: 'Manufacturer',
      part_number: 'Part Number',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/catalog/product.js